// Import components
import TextViewer from '../../components/TextViewer';

// Import hooks
import { useFetchTextFromDocument } from '../../utils/hooks/fetchTextFromDocument';

// Import components
import { ErrorMessage } from '../../components/Error';

// Import utils
import { Loader } from '../../utils/styles/Atoms';
import colors from '../../utils/styles/colors';

// Import text
import errorTexts from '../../texts/error';

// Store path of legals doc
const LEGAL_NOTICE_PATH = '/legals/legalNotices.txt';
const TERMES_OF_USE_PATH = '/legals/termesOfUse.txt';
const PRIVACY_POLICY_PATH = '/legals/privacyPolicy.txt';

// Legal page
function Legal({ page = null }) {
    // Get the file path
    let filePath = null;
    if (page === 'legal notices') {
        filePath = LEGAL_NOTICE_PATH;
    } else if (page === 'termes of use') {
        filePath = TERMES_OF_USE_PATH;
    } else if (page === 'privacy policy') {
        filePath = PRIVACY_POLICY_PATH;
    }

    // Get the text of the file
    const { text, isLoading, isError } = useFetchTextFromDocument(filePath);

    return (
        <>
            {isLoading ? (
                <Loader color={colors.primaryBeige} />
            ) : isError ? (
                <ErrorMessage
                    critical={true}
                    message={errorTexts.pageLoadingError}
                />
            ) : (
                <TextViewer text={text} />
            )}
        </>
    );
}

export default Legal;
